<div
  class="vq-popup-overlay"
  [class.vq-popup-overlay--dark]="isDarkMode()"
>
  <div
    class="vq-popup"
    [class.vq-popup--dark]="isDarkMode()"
    role="dialog"
    aria-labelledby="vq-popup-title"
    aria-modal="true"
  >
    <button
      type="button"
      class="vq-popup__close"
      aria-label="Close"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>

    <h2 class="vq-popup__title" id="vq-popup-title">Vessel Questionnaire</h2>
    <p class="vq-popup__subtitle">Choose an action to continue</p>

    <div class="vq-popup__options">
      <button
        *ngFor="let option of visibleOptions"
        type="button"
        class="vq-popup__option"
        (click)="select(option.action)"
      >
        <span class="vq-popup__option-icon" [ngClass]="option.iconClass">
          <mat-icon>{{ option.icon }}</mat-icon>
        </span>
        <span class="vq-popup__option-body">
          <span class="vq-popup__option-title">{{ option.title }}</span>
          <span class="vq-popup__option-desc">{{ option.description }}</span>
        </span>
        <mat-icon class="vq-popup__option-arrow">chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>
